import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { notifyError, notifySuccess } from './notify';

/** A mutation that refreshes the given queries, shows a success toast, and reports errors as toasts. */
export function useAction<TVars = void, TResult = unknown>(
  fn: (vars: TVars) => Promise<TResult>,
  opts: { success?: string | ((vars: TVars) => string); invalidate?: QueryKey[]; onDone?: (result: TResult, vars: TVars) => void } = {},
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: async (result, vars) => {
      await Promise.all((opts.invalidate ?? []).map((queryKey) => queryClient.invalidateQueries({ queryKey })));
      if (opts.success) notifySuccess(typeof opts.success === 'function' ? opts.success(vars) : opts.success);
      opts.onDone?.(result, vars);
    },
    onError: (error) => notifyError(error),
  });
}
